import { connectionType } from "constant";
import moment from "moment";
import { deviceType, controlType } from "constant";

export const isStale = function (car) {
  const isGasCtl = (ctl) => ctl === controlType.GCCM || ctl === "" || ctl == null || ctl == controlType.None;
  const timestamps = [
    car?.LastLocationUpdateInUtc,
    car?.LastRTInUtc,
    car?.LastWiFiInUtc
  ]
    .filter(Boolean)
    .map(d => moment.utc(d));

  if (!timestamps.length) {
    return false;
  }

  const latestTimestamp = moment.max(timestamps);
  const minutesSinceLastUpdate = moment().diff(latestTimestamp, "minutes");

  if (isGasCtl(car?.CarControlType) && car?.DevType === deviceType.FT2) {
    return minutesSinceLastUpdate > 70;
  }

  return car.Connection === connectionType.none;
};